export default function HeroSection() {
  return (
    <section className="relative pt-32 pb-20 sm:pt-40 sm:pb-28 lg:pt-48 lg:pb-32 overflow-hidden">
      <div className="absolute inset-0">
        <img 
          alt="デジタル制作サービス - モダンなオフィス環境でのデザイン作業、ミニマルで洗練された雰囲気、柔らかな自然光が差し込む明るい空間、ノートパソコンとデザインツール、クリーンでプロフェッショナルな印象" 
          className="w-full h-full object-cover object-top" 
          src="https://public.readdy.ai/ai/img_res/26095d126fe20c9ec2b7501a0314e7cf.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 text-center">
        <div className="inline-block bg-white/95 backdrop-blur-sm px-6 py-2 rounded-full mb-6">
          <span className="text-sm sm:text-base font-bold text-[#66BB6A]">企業様向けデジタル制作サービス</span>
        </div>

        <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          お客様のニーズを汲み取り、<br />
          ビジネスの成長に貢献いたします。
        </h1>

        <p className="text-lg sm:text-xl lg:text-2xl text-white/95 mb-8 max-w-4xl mx-auto leading-relaxed">
          チラシ制作・ネットショップ立ち上げ・タスク効率化アプリ制作<br className="hidden sm:block" />
          下記以外でもエクセルフォーム作成（半自動化）・AI導入など、お気軽にご相談ください
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="#services" 
            className="inline-flex items-center gap-2 bg-gradient-to-r from-[#66BB6A] to-[#4CAF50] text-white px-8 py-4 rounded-full text-lg font-bold shadow-xl hover:shadow-2xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-service-line text-xl"></i>
            サービス内容を見る
          </a>
          <a 
            href="#contact" 
            className="inline-flex items-center gap-2 bg-white/95 backdrop-blur-sm text-[#2C2C2C] px-8 py-4 rounded-full text-lg font-bold shadow-xl hover:shadow-2xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-send-line text-xl"></i>
            お問い合わせ
          </a>
        </div>
      </div>
    </section>
  );
}
